import { Container, Title, Text, Stack, Accordion, Box } from '@mantine/core';
import { useLanguage } from '@/context/LanguageContext';
import { useSEO, generateFAQStructuredData } from '@/lib/useSEO';

export default function FaqPage() {
  const { t } = useLanguage();

  const faqItems = [
    {
      value: 'order',
      question: t('faq.questions.order.question'),
      answer: t('faq.questions.order.answer'),
    },
    {
      value: 'payment',
      question: t('faq.questions.payment.question'),
      answer: t('faq.questions.payment.answer'),
    },
    {
      value: 'shipping',
      question: t('faq.questions.shipping.question'),
      answer: t('faq.questions.shipping.answer'),
    },
    {
      value: 'returns',
      question: t('faq.questions.returns.question'),
      answer: t('faq.questions.returns.answer'),
    },
    {
      value: 'warranty',
      question: t('faq.questions.warranty.question'),
      answer: t('faq.questions.warranty.answer'),
    },
    {
      value: 'account',
      question: t('faq.questions.account.question'),
      answer: t('faq.questions.account.answer'),
    },
    {
      value: 'product',
      question: t('faq.questions.product.question'),
      answer: t('faq.questions.product.answer'),
    },
    {
      value: 'contact',
      question: t('faq.questions.contact.question'),
      answer: t('faq.questions.contact.answer'),
    },
  ];

  // Generate FAQ structured data for SEO
  const faqStructuredData = generateFAQStructuredData(
    faqItems.map(item => ({ question: item.question, answer: item.answer }))
  );

  // SEO for FAQ page
  useSEO({
    title: t('seo.faq.title') || 'FAQ - Luxelo',
    description: t('seo.faq.description') || 'Find answers to frequently asked questions about Luxelo products, shipping, returns, and more.',
    type: 'website',
    structuredData: faqStructuredData,
  });

  return (
    <Container size="xl" py="xl">
      <Stack gap="xl">
        <Box>
          <Title order={1} mb="md">{t('faq.title')}</Title>
          <Text size="lg" c="dimmed">
            {t('faq.subtitle')}
          </Text>
        </Box>

        <Accordion variant="separated" radius="md">
          {faqItems.map((item) => (
            <Accordion.Item key={item.value} value={item.value}>
              <Accordion.Control>
                <Text fw={600}>{item.question}</Text>
              </Accordion.Control>
              <Accordion.Panel>
                <Text size="sm" c="dimmed" style={{ whiteSpace: 'pre-line' }}>
                  {item.answer}
                </Text>
              </Accordion.Panel>
            </Accordion.Item>
          ))}
        </Accordion>

        <Box pt="md">
          <Text size="md" c="dimmed">
            {t('faq.notFound')}
          </Text>
        </Box>
      </Stack>
    </Container>
  );
}

